const searchStrip = {
  hotels: "Hotels", // translated
  city: "Stadt", // translated
  checkIn: "Check-In", // translated
  checkOut: "Kasse", // translated
  date: "Datum", // translated
  persons: "Personen", // translated
  adults: "Erwachsene", // translated
  rooms: "Räume", // translated
  editSearch: "Suche bearbeiten", // translated
  newSearch: "Neue Suche", // translated
  listView: "Listenansicht", // translated
  mapView: "Kartenansicht", // translated
};

export default searchStrip;
